import { client } from "api";
import { SerialEntity } from "models/Checklist";

export type MoveSerialEntityRequest = {
  serialId: SerialEntity["id"];
  originalChecklistId: string;
  targetChecklistId: string;
};

export type MoveSerialEntityResponse = SerialEntity;

export const moveSerialEntity = ({ originalChecklistId, ...request }: MoveSerialEntityRequest) =>
  client
    .patch<MoveSerialEntityResponse>(`/checklist/${originalChecklistId}/move-serialEntity`, request)
    .then((res) => res.data);
